export const formatOperationalAuditEnum = (
  value,
  fallback = "Other",
) => {
  if (!value) {
    return fallback;
  }

  return value
    .toLowerCase()
    .split("_")
    .map(
      (word) =>
        word.charAt(0).toUpperCase() +
        word.slice(1),
    )
    .join(" ");
};